import { Card, CardBody } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { CUSTOM_BUTTONS } from "../../../../Data/Buttons/DefaultStyle";
import { CustomStateButton } from "../../../../Constant";
import { CUSTOM_STATE_DATA } from "../../../../Data/Buttons/EdgeStyle";
import CommonEdgeCustomStateButtons from "./CommonEdgeCustomStateButtons";

const EdgeCustomStateButtons = () => {
  return (
    <Card>
      <CommonCardHeader title={CustomStateButton} span={CUSTOM_BUTTONS} />
      <CardBody className="btn-showcase">
        {CUSTOM_STATE_DATA.map((item, index) => (
          <CommonEdgeCustomStateButtons data={item} key={index} />
        ))}
      </CardBody>
    </Card>
  );
};

export default EdgeCustomStateButtons;
